export const pathLogClient = ["wom"]
